<style scoped>
.profile-wrapper {
  padding: 24px;
}
.red-text {
  color: red;
}
</style>

<template>
  <mu-container class="component-wrapper">
    <mu-paper :z-depth="1" class="profile-wrapper">
      <mu-list textline="two-line">
        <mu-sub-header inset>{{$t('profile.title')}}</mu-sub-header>
        <mu-list-item avatar button :ripple="false" @click="flagDialogEditAvatar = true">
          <mu-list-item-action>
          <mu-avatar>
            <img :src="stringProfile" v-if="$store.state.auth.user.profile !== '' && $store.state.auth.user.profile !== undefined">
            <img :src="defaultAvatar" v-else>
          </mu-avatar>
          </mu-list-item-action>
          <mu-list-item-content>
          <mu-list-item-title>{{$store.state.auth.user.username}}</mu-list-item-title>
          <mu-list-item-sub-title>{{$t('profile.username')}}</mu-list-item-sub-title>
          </mu-list-item-content>
          <mu-list-item-action>
          <mu-icon value="edit" />
          </mu-list-item-action>
        </mu-list-item>
        <mu-list-item :ripple="false">
          <mu-list-item-action>
          <mu-icon value="enhanced_encryption" />
          </mu-list-item-action>
          <mu-list-item-content>
          <mu-list-item-title>{{$t('profile.type.' + this.$store.state.auth.user.type)}}</mu-list-item-title>
          <mu-list-item-sub-title>{{$t('profile.type.display')}}</mu-list-item-sub-title>
          </mu-list-item-content>
        </mu-list-item>
        <mu-list-item button :ripple="false" @click="onClickEditName">
          <mu-list-item-action>
          <mu-icon value="perm_identity" />
          </mu-list-item-action>
          <mu-list-item-content>
          <mu-list-item-title>{{stringFullname}}</mu-list-item-title>
          <mu-list-item-sub-title>{{$t('profile.fullname')}}</mu-list-item-sub-title>
          </mu-list-item-content>
          <mu-list-item-action v-if="isGuest">
          <mu-icon value="edit" />
          </mu-list-item-action>
        </mu-list-item>
        <mu-list-item button :ripple="false" @click="onClickEditEmail">
          <mu-list-item-action>
          <mu-icon value="contact_mail" />
          </mu-list-item-action>
          <mu-list-item-content>
          <mu-list-item-title>{{stringEmail}}</mu-list-item-title>
          <mu-list-item-sub-title>{{$t('profile.email')}}</mu-list-item-sub-title>
          </mu-list-item-content>
          <mu-list-item-action v-if="isGuest">
          <mu-icon value="edit" />
          </mu-list-item-action>
        </mu-list-item>
        <mu-list-item :ripple="false">
          <mu-list-item-action>
          <mu-icon value="verified_user" />
          </mu-list-item-action>
          <mu-list-item-content>
          <mu-list-item-title>{{stringRole}}</mu-list-item-title>
          <mu-list-item-sub-title>{{$t('profile.role')}}</mu-list-item-sub-title>
          </mu-list-item-content>
        </mu-list-item>
        <mu-list-item button :ripple="false" @click="flagDialogEditPassword = true" v-if="isGuest">
          <mu-list-item-action>
          <mu-icon value="lock" />
          </mu-list-item-action>
          <mu-list-item-content>
          <mu-list-item-title>{{$t('profile.password.display')}}</mu-list-item-title>
          </mu-list-item-content>
          <mu-list-item-action v-if="isGuest">
          <mu-icon value="edit" />
          </mu-list-item-action>
        </mu-list-item>
      </mu-list>
    </mu-paper>
    <mu-dialog :title="$t('button.edit') + $t('space') + $t('profile.email')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogEditEmail">
      <mu-form :model="form" label-width="500">
        <mu-form-item prop="input" :label="$t('profile.email')">
          <mu-text-field v-model="modelEmail"></mu-text-field>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="primary" @click="flagDialogEditEmail = false"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
      <mu-button slot="actions" flat color="primary" @click="onActionEditEmail"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
    <mu-dialog :title="$t('button.edit') + $t('space') + $t('profile.email')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogEditName">
      <mu-form :model="form" label-width="500">
        <mu-form-item prop="input" :label="$t('profile.fullname')">
          <mu-text-field v-model="modelName"></mu-text-field>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="primary" @click="flagDialogEditName = false"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
      <mu-button slot="actions" flat color="primary" @click="onActionEditName"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
    <mu-dialog :title="$t('button.edit') + $t('space') + $t('profile.avatar')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogEditAvatar">
      <mu-flex class="flex-wrapper" justify-content="center">
        <mu-avatar :size="100">
          <img :src="stringProfile" v-if="$store.state.auth.user.profile !== '' && $store.state.auth.user.profile !== undefined">
          <img :src="defaultAvatar" v-else>
        </mu-avatar>
      </mu-flex>
      <mu-flex class="flex-wrapper" justify-content="center">
        <mu-button @click="onActionDeleteProfile" v-if="$store.state.auth.user.profile !== '' && $store.state.auth.user.profile !== undefined">{{$t('profile.deleteCurrentAvatar')}}</mu-button>
      </mu-flex>
      <br />
      <mu-flex class="flex-wrapper" justify-content="center">
        <input type="file" id="file" ref="file" @change="onFileChange" />
      </mu-flex>
      <mu-button slot="actions" flat color="primary" @click="flagDialogEditAvatar = false"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
      <mu-button slot="actions" flat color="primary" @click="onActionEditProfile"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
    <mu-dialog :title="$t('button.edit') + $t('space') + $t('profile.password.display')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogEditPassword">
      <mu-form :model="form" label-width="500">
        <mu-form-item prop="input" :label="$t('profile.password.old')">
          <mu-text-field v-model="modelPasswordOld" :action-icon="visibility1 ? 'visibility_off' : 'visibility'" :action-click="() => (visibility1 = !visibility1)" :type="visibility1 ? 'text' : 'password'"></mu-text-field>
        </mu-form-item>
        <mu-form-item prop="input" :label="$t('profile.password.new')">
          <mu-text-field v-model="modelPasswordNew" :action-icon="visibility2 ? 'visibility_off' : 'visibility'" :action-click="() => (visibility2 = !visibility2)" :type="visibility2 ? 'text' : 'password'"></mu-text-field>
        </mu-form-item>
        <mu-form-item prop="input" :label="$t('profile.password.new') + $t('profile.password.again')">
          <mu-text-field v-model="modelPasswordNewAgain" :action-icon="visibility3 ? 'visibility_off' : 'visibility'" :action-click="() => (visibility3 = !visibility3)" :type="visibility3 ? 'text' : 'password'"></mu-text-field>
        </mu-form-item>
        <span class="red-text">{{stringPasswordError}}</span>
      </mu-form>
      <mu-button slot="actions" flat color="primary" @click="flagDialogEditPassword = false"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
      <mu-button slot="actions" flat color="primary" @click="onActionEditPassword"><mu-icon value="check" :disabled="!isPasswordValid"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
  </mu-container>
</template>

<script>
// Library
import axios from "axios";

// Assets
import defaultAvatar from '@/assets/img/default_avatar.png'

export default {
  name: 'ProfilePage',
  data() {
    return {
      // Flag
      flagDialogEditEmail: false, // Boolean variable for status of edit email dialog
      flagDialogEditName: false, // Boolean variable for status of edit name dialog
      flagDialogEditAvatar: false, // Boolean variable for status of edit avatar dialog
      flagDialogEditPassword: false, // Boolean variable for status of edit password dialog
      visibility1: false,
      visibility2: false,
      visibility3: false,

      // Model
      modelEmail: this.$store.state.auth.user.email, // Bind with email input
      modelName: this.$store.state.auth.user.name, // Bind with name input
      modelFilename: "", // Bind with file name input
      modelFile: "", // Bind with file input
      modelPasswordOld: "",
      modelPasswordNew: "",
      modelPasswordNewAgain: "",
      form: {},

      // String
      msgError: "",
    }
  },
  computed: {
    // Asset
    defaultAvatar() {
      return defaultAvatar;
    },

    // String
    stringFullname() {
      if (typeof this.$store.state.auth.user.name === "undefined")
        return "Not specified";
      else
        return this.$store.state.auth.user.name;
    },
    stringRole() {
      return this.$store.state.auth.user.roles.join(", ");
    },
    stringProfile() {
      return this.$store.getters.urlStorage + "profile/" + this.$store.state.auth.user.profile + "?rand=" + new Date().getUTCMilliseconds();
    },
    stringEmail() {
      if (typeof this.$store.state.auth.user.email === "undefined")
        return "Not specified";
      else
        return this.$store.state.auth.user.email;
    },
    stringPasswordError() {
      if(this.modelPasswordNew === '' || this.modelPasswordNewAgain === '') {
        return "";
      } else {
        if(this.modelPasswordNew === this.modelPasswordNewAgain) {
          return "";
        } else {
          return this.$t('profile.password.error');
        }
      }
    },

    // Flag
    isGuest(){
      return this.$store.state.auth.user.type === "guest";
    },
    isPasswordValid() {
      if((this.modelPasswordOld !== "" && this.modelPasswordNew !== "" && this.modelPasswordNewAgain !== "") &&
      this.modelPasswordNew === this.modelPasswordNewAgain) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {

  },
  methods: {
    // Event
    onClickEditName() {
      if(this.isGuest)
        this.flagDialogEditName = true;
    },
    onClickEditEmail() {
      if(this.isGuest)
        this.flagDialogEditEmail = true;
    },
    onActionEditEmail() {
      this.flagDialogEditEmail = false;
      axios.put(this.$store.getters.urlApi + "user", {
        'email': this.modelEmail
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.$toast.success(this.$t('toast.edit'));
      });
    },
    onActionEditName() {
      this.flagDialogEditName = false;
      axios.put(this.$store.getters.urlApi + "user", {
        'name': this.modelName
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.$toast.success(this.$t('toast.edit'));
      });
    },
    onActionEditProfile() {
      this.flagDialogEditAvatar = false;
      let formData = new FormData();
      formData.append('file', this.modelFile);
      formData.append('modelFilename', this.modelFilename);
      axios.post(this.$store.getters.urlApi + "user/profile", formData, {
        headers: {
          token: this.$store.state.auth.token
        },
        }
      ).then(() => {
        this.$toast.success(this.$t('profile.avatarMessage'));
      });
    },
    onActionDeleteProfile() {
      this.flagDialogEditAvatar = false;
      axios.delete(this.$store.getters.urlApi + "user/profile", {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(() => {
        this.$toast.success(this.$t('profile.avatarMessage'));
      });
    },
    onActionEditPassword() {
      this.flagDialogEditPassword = false;
      axios.put(this.$store.getters.urlApi + "user/password", {
        'password_old': this.modelPasswordOld,
        'password_new': this.modelPasswordNew
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.$toast.success(this.$t('toast.edit'));
      });
    },
    onFileChange() {
      this.modelFile = this.$refs.file.files[0];
      this.modelFilename = this.$refs.file.files[0].name;
    }
  },
}
</script>
